import { Tooltip } from "@mui/material";

export function DTooltip({ hints }: { hints: string }) {
  return (
    <Tooltip title={hints}>
      <span style={{ marginLeft: 5 }}>ⓘ</span>
    </Tooltip>
  );
}
